import React, { Component } from "react";
import { Modal } from "reactstrap";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
import { Mutation } from "@apollo/client/react/components";

import { Button } from "../../Button";
import { UPDATE_USER_SUBSCRIPTION } from "../../../gql/mutations";
import { TierItem } from "../../../typings/pricing";
import { SubscriptionContext } from "../../../services/SubscriptionService";
import GAService from "../../../services/GAService";
import AnalyticsService from "../../../services/AnalyticsService";
import styles from "./styles.scss";

export interface ReactivateModalProps {
  visible: boolean;
  toggleModal(): void;
  userSubscription?: any;
  currentTier?: TierItem;
}

export interface ReactivateModalState {
  loading: boolean;
}

class ReactivateModal extends Component<ReactivateModalProps, ReactivateModalState> {
  constructor(props: ReactivateModalProps) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  render() {
    const { loading } = this.state;
    const { visible, toggleModal, userSubscription, currentTier } = this.props;
    return (
      <Mutation mutation={UPDATE_USER_SUBSCRIPTION}>
        {(updateUserSubscription: any, { error }: any) => (
          <SubscriptionContext.Consumer>
            {({ subscriptionSports, subscriptionUpgradeSource }) => (
              <Modal
                className={"rotoql-reactivate-modal__dialog"}
                contentClassName="rotoql-reactivate-modal__content"
                modalClassName="rotoql-reactivate-modal"
                wrapClassName="rotoql-reactivate-modal__wrapper"
                backdropClassName="rotoql-reactivate-modal__backdrop"
                isOpen={visible}
                slide="false"
                size="lg"
                centered
              >
                <div className="rotoql-reactivate-modal__close" onClick={() => !loading && toggleModal()}>
                  <Icon path={mdiClose} size="20px" color="#262626" />
                </div>
                <div className="rotoql-reactivate-modal__body-text">
                  Are you sure you want to reactivate your subscription?
                </div>
                {error ? <div className="rotoql-reactivate-modal__error-text">{error}</div> : null}
                <div className="rotoql-reactivate-modal__button-container">
                  <Button
                    className="rotoql-reactivate-modal__button"
                    onClick={async () => {
                      const trackingProps = {
                        screen: "ReactivateModal",
                        page: "Pricing",
                        tab: currentTier ? currentTier.durationTitle : undefined,
                        subscriptionLevel: currentTier
                          ? `${currentTier.title} ${currentTier.durationTitle}`
                          : undefined,
                        sports: subscriptionSports.length ? subscriptionSports.toString() : "All",
                        upgradeSource: subscriptionUpgradeSource,
                      };
                      this.setState({ loading: true });
                      try {
                        await updateUserSubscription({
                          variables: {
                            currentUserSubscriptionId: userSubscription.id,
                            cancelAtPeriodEnd: false,
                          },
                          errorPolicy: "all",
                          awaitRefetchQueries: true,
                          refetchQueries: () => ["pricingPageQuery", "userSubscriptionQuery"],
                        });
                        toggleModal();
                        AnalyticsService.track("Reactivate Subscription", {
                          ...trackingProps,
                          success: true,
                        });
                        GAService.sendEvent({
                          hitType: "event",
                          eventCategory: "Reactivate",
                          eventAction: window.location.href,
                          eventLabel: currentTier ? currentTier.key : undefined,
                        });
                      } catch (e: any) {
                        console.log("Error reactivating subscription: ", e.message);
                        AnalyticsService.track("Reactivate Subscription", {
                          ...trackingProps,
                          success: false,
                        });
                      }
                      this.setState({ loading: false });
                    }}
                  >
                    YES, REACTIVATE
                  </Button>
                  <Button
                    className="rotoql-reactivate-modal__button rotoql-reactivate-modal__button--cancel"
                    onClick={() => {
                      toggleModal();
                    }}
                  >
                    NO, GO BACK
                  </Button>
                </div>
                <style jsx>{styles}</style>
              </Modal>
            )}
          </SubscriptionContext.Consumer>
        )}
      </Mutation>
    );
  }
}

export default ReactivateModal;
